import { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { jsonLdScriptProps } from 'react-schemaorg';
import { Graph, ListItem, Thing, WebPage } from 'schema-dts';
import { useBreadcrumbsType } from '../../../components/pages/vehicle/hooks/use-breadcrumbs';

const useSchema = ({
  name,
  description,
  breadcrumbs,
  extraSchema = [],
}: {
  name: string;
  description: string;
  breadcrumbs: ReturnType<useBreadcrumbsType>;
  extraSchema?: any[];
}) => {
  const { locale = 'en', asPath } = useRouter();
  const localePath = locale !== 'en' ? `/${locale}` : '';
  const cleanAsPathForCanonicalURL = asPath.split('?')[0];

  let rootUrl = `${process.env.NEXT_PUBLIC_HOST}${localePath}`;
  if (cleanAsPathForCanonicalURL.startsWith('/service-box')) {
    rootUrl = `${process.env.NEXT_PUBLIC_HOST}${localePath}/service-box`;
  } else if (cleanAsPathForCanonicalURL.startsWith('/pro')) {
    rootUrl = `${process.env.NEXT_PUBLIC_HOST}${localePath}/pro/v2`;
  }

  return jsonLdScriptProps({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}#webpage`,
        url: `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}`,
        inLanguage: locale,
        name,
        description,
        breadcrumb: {
          '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}#breadcrumb`,
        },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${process.env.NEXT_PUBLIC_HOST}${localePath}${cleanAsPathForCanonicalURL}#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            item: {
              '@type': 'WebPage',
              '@id': rootUrl,
              url: rootUrl,
              name: 'Home',
            },
          },
          ...breadcrumbs
            .filter(({ text, as, href }) => !!text && !!(as || href.as))
            .map<ListItem>((item, index) => {
              const itemAsString = String(item.as || item.href?.as);
              const asPathToShow = itemAsString
                ? itemAsString.split('?')[0]
                : '';
              return {
                '@type': 'ListItem',
                position: index + 2,
                item: {
                  '@type': 'WebPage',
                  '@id': `${process.env.NEXT_PUBLIC_HOST}${asPathToShow}`,
                  url: `${process.env.NEXT_PUBLIC_HOST}${asPathToShow}`,
                  name: item.text,
                },
              };
            }),
        ],
      },
      ...extraSchema,
    ],
  });
};

export default useSchema;
